import classNames from 'classnames';
import BgIcon from 'components/atoms/icons/condition-filter-bg.svg?react';
import { type FC } from 'react';

import s from './style.module.scss';

type Props = {
  title: string;
  count?: number;
  bgColor: string;
};

const MiniStatsActive: FC<Props> = (props) => {
  const { title, count, bgColor } = props;
  return (
    <div className={classNames(s.item)}>
      <p className={s.buttonActiveTitle}>{title}</p>
      <p className={s.count}>{count}</p>
      <BgIcon className={s.bg} color={bgColor} />
    </div>
  );
};

export default MiniStatsActive;
